<script>
  import Form from "./Form.svelte";
  import { focusNext } from "./Form.svelte";

  import { HStack } from "../component/layout";
  import { Padding } from "../component/modifier";
  import { Digit } from "./widget";
  import { navigate } from "../router";
  import { check, join, load } from "../wedding.js";

  let step = 1;
  let steps = [
    {
      id: 1,
      name: "Code Invitation",
      done: false,
      back: false,
      cancel: true,
      submit: "continue",
      next: 2,
      prev: null,
    },
    {
      id: 2,
      name: "Rejoindre Mariage",
      done: false,
      back: true,
      cancel: true,
      submit: "validate",
      next: 3,
      prev: 1,
    },
    {
      id: 3,
      name: "Félicitations",
      done: false,
      back: false,
      cancel: false,
      submit: "final",
      next: null,
      prev: 2,
    },
  ];

  let form = undefined;

  let c1 = null;
  let c2 = null;
  let c3 = null;
  let c4 = null;
  let c5 = null;
  let c6 = null;
  let code;
  let current = "";
  let wedding;

  const submit = async () => {
    console.log("submit", step);

    if (step == 1) {
      code = "" + c1 + c2 + c3 + c4 + c5 + c6;
      let result = await check(code);
      wedding = result.data;
    } else if (step == 2) {
      await join(wedding.guid, wedding.code, code);
    } else if (step == 3) {
      load();
      navigate(`#/wedding/${wedding.guid}/A`);
    }
  };

  function validate(event) {
    switch (event.target.name) {
      case "c1":
      case "c2":
      case "c3":
      case "c4":
      case "c5":
      case "c6":
        if (
          event.target.value === "" ||
          event.target.value === null ||
          event.target.value === undefined
        ) {
          event.target.setCustomValidity("Un chiffre est requis.");
        } else {
          event.target.setCustomValidity("");
          focusNext(form);
        }
        break;
      default:
        break;
    }
  }
</script>

<Form
  bind:form
  bind:step
  bind:steps
  {submit}
  {validate}
  validateButton={"Rejoindre"}
  backButton={"Pas le bon mariage"}
  on:close
  padding={false}>
  <div>
    {#if step == 1}
      <p>Entrez votre code d'invitation pour continuer.</p>
      <Padding>
        <HStack justify="space-evenly" alignment="normal">
          <Digit id={"c1"} focused bind:value={c1} bind:current />
          <Digit id={"c2"} bind:value={c2} bind:current />
          <Digit id={"c3"} bind:value={c3} bind:current />
          <Digit id={"c4"} bind:value={c4} bind:current />
          <Digit id={"c5"} bind:value={c5} bind:current />
          <Digit id={"c6"} bind:value={c6} bind:current />
        </HStack>

        <p style="text-align: justify;font-size: small;">
          Si vous avez reçu un faire-part par e-mail, ce code n'est pas nécessaire. Il vous suffit
          d'utiliser le lien ou le QR code qui vous a été envoyé.
        </p>
        <p style="text-align: justify;font-size: small;">
          Si vous n'avez pas reçu de faire-part, veuillez contacter les mariés.
        </p>
      </Padding>
    {:else if step == 2}
      <h1>
        Bienvenue au mariage de
        <br />
        {wedding.name} !
      </h1>
      <p>Pour accéder au blog du mariage, cliquez sur Rejoindre.</p>
    {:else if step == 3}
      <h1>Félicitations !</h1>
      <p>Tout est prêt, vous pouvez désormais accéder au blog du mariage et répondre au RSVP.</p>
    {/if}
  </div>
</Form>

<style>
  div {
    height: 300px;
    width: 480px;
  }

  @media screen and (max-width: 600px) {
    div {
      width: 100%;
    }
  }

  h1 {
    font-family: "Cinzel";
    font-size: 1.5rem;
    text-align: center;
  }
</style>
